import { helper } from '@ember/component/helper';

export default helper(function defaultTo([a, b]) {
  return a ?? b;
});
